/**
 * 결제 거래 API
 * FSD: features/subscription/payment-history/api
 */

import { apiClient } from "@/shared/api/client";
import type { PaymentTransaction } from "@/entities/payment/model";

class TransactionAPI {
  async getUserTransactions(): Promise<PaymentTransaction[]> {
    try {
      const response = await apiClient.get(`/v1/payment/transactions`);
      return response.data.data || [];
    } catch (error: any) {
      throw new Error(error.response?.data?.message || "거래 내역 조회 실패");
    }
  }

  async getTransaction(transactionId: string): Promise<PaymentTransaction> {
    try {
      const response = await apiClient.get(
        `/v1/payment/transaction/${transactionId}`
      );
      return response.data.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || "거래 조회 실패");
    }
  }

  async cancelPayment(tid: string, amount: string, reason: string) {
    try {
      const response = await apiClient.post("/v1/payment/cancel", {
        TID: tid,
        CancelAmt: amount,
        CancelMsg: reason,
      });
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || "결제 취소 실패");
    }
  }
}

export const transactionAPI = new TransactionAPI();
